import { useNavigate } from "react-router-dom";

import OfferIcon from "atoms/icon/icons/ic_offers_ol.svg";
import OpenRewardIcon from "atoms/icon/icons/open_reward.svg";
import { ActionModal } from "molecules/modal-window/action-modal/ActionModal";

type SimpleInclusionModel = {
  unitType: string;
  quantity: number;
  id: string;
  name: string;
};

interface ItemAppliedToCartModalProps {
  onClose: () => void;
  itemName?: string | null;
  itemType: "reward" | "offer";
  redeemedInclusions: SimpleInclusionModel[];
  hasMembershipInclusions: boolean;
}

export const RedeemedFreePackageGroupModal = ({
  onClose,
  itemName,
  itemType,
  redeemedInclusions,
  hasMembershipInclusions,
}: ItemAppliedToCartModalProps) => {
  const navigate = useNavigate();

  const itemTypeTitleCase =
    itemType.charAt(0).toUpperCase() + itemType.slice(1).toLowerCase();

  const icon = itemType === "reward" ? OpenRewardIcon : OfferIcon;

  return (
    <ActionModal
      size="small"
      open={true}
      headerIconSvg={icon}
      onClose={onClose}
      onFirstButtonClick={() =>
        navigate(hasMembershipInclusions ? "/cart" : "/wallet/treatments")
      }
      firstButtonLabel={
        hasMembershipInclusions ? "View my cart" : "View my treatments"
      }
      title={`Congratulations! Your ${itemTypeTitleCase} has been redeemed.`}
      useAnimatedBackground={true}
      description={
        !!itemName && (
          <FreePackageGroupsRedeemed redeemedInclusions={redeemedInclusions} />
        )
      }
    />
  );
};

const FreePackageGroupsRedeemed = ({
  redeemedInclusions,
}: {
  redeemedInclusions: SimpleInclusionModel[];
}) => {
  return (
    <div className="mb-5 rounded">
      {redeemedInclusions.map((inclusion, index, array) => (
        <>
          <div
            key={inclusion.id}
            className="my-4 flex w-full items-center gap-3"
          >
            <div className="flex w-full flex-col items-start gap-2 text-left">
              <div className="text-body1 text-primary">{inclusion.name}</div>
              <div className="text-body1 text-primary">
                {inclusion.quantity} {inclusion.unitType}
              </div>
            </div>
            <div className="text-body1 uppercase">free</div>
          </div>
          {
            // Add divider at the bottom of each element except the last one
            array.length - 1 !== index && (
              <div className="w-full border-b border-gray-100"></div>
            )
          }
        </>
      ))}
    </div>
  );
};
